import {ref} from "vue";

export const inputError = ref({})

export const checkInput = (event, form) => {
    inputError.value[event.target.name] = form[event.target.name] == '' || form[event.target.name] == null;
}
